<ng-container *ngIf="scrollbarEnabled; else noScrollbar">
  <div class="shrd-uic-flyout-body-container has-scrollbar" shrdUicScrollbar [scrollBarVerticalRef]="scrollbar">
    <ng-container *ngTemplateOutlet="container"></ng-container>
  </div>
  <shrd-uic-scrollbar #scrollbar></shrd-uic-scrollbar>
</ng-container>

<ng-template #noScrollbar>
  <div class="shrd-uic-flyout-body-container">
    <ng-container *ngTemplateOutlet="container"></ng-container>
  </div>
</ng-template>

<ng-template #flyoutBody>
  <ng-container *ngIf="hasGrid; else noGrid">
    <div class="container-fluid my-0 px-md-0">
      <div class="row">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #noGrid>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content><ng-content></ng-content></ng-template>

<ng-template #container>
  <ng-container *ngIf="focusEnabled; else noFocusContainer">
    <div shrdUicFocusTrap [autoUpdate]="autoUpdateFocusScope">
      <ng-container *ngTemplateOutlet="flyoutBody"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #noFocusContainer>
  <ng-container *ngTemplateOutlet="flyoutBody"></ng-container>
</ng-template>
